// extracted by mini-css-extract-plugin
export var leftAlign = "_t-2";
export var popper = "_t-0";
export var subtitle = "_t-1";